import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import {
  readCookiePreferences,
  saveCookiePreferences,
  applyAnalyticsToVendors,
} from '../utils/cookiePreferences';
import './CookieConsent.css';

const CookieConsent: React.FC = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const prefs = readCookiePreferences();
    applyAnalyticsToVendors(prefs.analytics);
    if (!prefs.bannerDismissed) {
      setShowBanner(true);
    }
  }, []);

  const dismissBanner = () => {
    const prefs = readCookiePreferences();
    saveCookiePreferences({ ...prefs, bannerDismissed: true });
    setShowBanner(false);
  };

  const handleOkay = () => {
    dismissBanner();
  };

  const handleManageClick = () => {
    dismissBanner();
  };

  return (
    <AnimatePresence>
      {showBanner && (
        <motion.div
          className="cookie-consent"
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.3, ease: 'easeOut' }}
          role="dialog"
          aria-label="Cookie notice">
          <div className="cookie-content">
            <p className="cookie-copy">
              <span className="cookie-copy-main">
                Cookies help us run the site and measure traffic (on by default).
              </span>{' '}
              <Link
                to="/cookie-preferences"
                className="cookie-link-subtle"
                onClick={handleManageClick}>
                Preferences
              </Link>
              <span className="cookie-copy-sep" aria-hidden="true">
                {' · '}
              </span>
              <a
                href="https://codec422.com/privacy"
                target="_blank"
                rel="noopener noreferrer"
                className="cookie-link-subtle">
                Privacy
              </a>
            </p>
            <button
              type="button"
              className="cookie-btn-okay"
              onClick={handleOkay}>
              Okay
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieConsent;
